import { type EnvironmentProviders, provideAppInitializer } from '@angular/core';

function initialize(id: string): () => void {
  return () => {
    if (!id) {
      return;
    }

    const script1 = document.createElement('script');
    script1.async = true;
    script1.src = `https://www.googletagmanager.com/gtag/js?id=${id}`;
    document.head.appendChild(script1);

    window.gtag?.('js', new Date());
    window.gtag?.('config', id);
  };
}

export function provideAnalytics(id: string): EnvironmentProviders {
  return provideAppInitializer(initialize(id));
}
